// What a copy or translation downloads as - mirror of backend/app/constants.py DownloadFormat;
// the value is the file's extension.
export const DOWNLOAD_FORMATS = { docx: 'docx', idml: 'idml' };

// The media types each format arrives as, with the extension it is saved under - mirror of backend app/constants.py
// DOCX_MIME_TYPE and app/idml/writer.py MIMETYPE.
const DOWNLOADED_FILES = {
  [DOWNLOAD_FORMATS.docx]: {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  },
  [DOWNLOAD_FORMATS.idml]: {
    'application/vnd.adobe.indesign-idml-package': 'idml',
  },
};
const DOWNLOADED_EXTENSIONS = new Set(Object.values(DOWNLOADED_FILES).flatMap(Object.values));

export function downloadedExtension(fileFormat, mediaType) {
  const accepted = DOWNLOADED_FILES[fileFormat];
  if (!accepted) {
    throw new TypeError(`Expected a download format of ${Object.keys(DOWNLOADED_FILES).join(', ')}, got ${fileFormat}`);
  }
  const extension = accepted[mediaType];
  if (!extension) {
    throw new Error(`Expected a ${fileFormat} download as ${Object.keys(accepted).join(' or ')}, got ${mediaType}`);
  }
  return extension;
}

// Downloadable translated file name pattern.
// Mirror of backend/app/constants.py TRANSLATED_FILENAME_TEMPLATE -
// keep them in sync; the backend sends the same name via
// Content-Disposition but the browser's `a.download` attribute
// overrides it, so the frontend must build the same string.
export const TRANSLATED_FILENAME_TEMPLATE = "{from_lang}_{to_lang}_{base_name}.{extension}";

export function translatedFilename(fromLang, toLang, baseName, extension) {
  if (!DOWNLOADED_EXTENSIONS.has(extension)) {
    throw new TypeError(`Expected a file extension of ${[...DOWNLOADED_EXTENSIONS].join(', ')}, got ${extension}`);
  }
  return TRANSLATED_FILENAME_TEMPLATE
    .replace("{from_lang}", fromLang)
    .replace("{to_lang}", toLang)
    .replace("{base_name}", baseName)
    .replace("{extension}", extension);
}
